<template>
  <v-card class="text-center pa-2" elevation="10" light>
    <v-card-title class="justify-center display-1 mb-2">{{
      $t('forgot.title')
    }}</v-card-title>
    <v-card-subtitle>
      {{ $t('forgot.subtitle') }}
    </v-card-subtitle>

    <v-card-text>
      <v-form ref="form" lazy-validation @submit.prevent="submit">
        <v-text-field
          v-model="email"
          :rules="[rules.required]"
          :validate-on-blur="false"
          :label="$t('fields.email')"
          outlined
          @keyup.enter="submit"
        ></v-text-field>

        <v-btn
          :loading="isLoading"
          :disabled="isLoading"
          block
          x-large
          color="primary"
          @click="submit"
          >{{ $t('forgot.button') }}</v-btn
        >
      </v-form>
      <div class="text-center mt-6">
        <router-link :to="localePath('/auth/signin')">
          {{ $t('forgot.backtosign') }}
        </router-link>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'ForgotPassword',
  layout: 'auth',
  auth: 'guest',
  data() {
    return {
      isLoading: false,
      email: '',
      rules: {
        required: (value) => (value && Boolean(value)) || 'Câmp Obligatoriu',
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

          return pattern.test(value) || 'E-mail invalid.'
        },
      },
    }
  },
  head() {
    return {
      title: 'Am uitat parola',
    }
  },
  methods: {
    async submit() {
      if (this.$refs.form.validate()) {
        this.isLoading = true
        try {
          const { data } = await this.$axios.post('/api/forgot-password', {
            email: this.email,
          })

          await this.$successAlert(data.message)
          await this.$router.replace('/auth/signin')
        } catch (e) {
          await this.$errorAlert('Emailul nu a putut fii trimis.')
        }
        this.isLoading = false
      }
    },
  },
}
</script>
